import type { ComponentType, SVGProps } from 'react';
import { DocumentTextIcon, FilmIcon, PaperClipIcon, PhotoIcon } from '@heroicons/react/24/outline';
import { attachmentIconKind, type AttachmentIconKind } from './attachmentDisplay';

const ICONS: Record<AttachmentIconKind, ComponentType<SVGProps<SVGSVGElement>>> = {
    image: PhotoIcon,
    video: FilmIcon,
    pdf: DocumentTextIcon,
    file: PaperClipIcon
};

interface AttachmentTypeIconProps {
    mimeType: string;
    className?: string;
}

function AttachmentTypeIcon({ mimeType, className }: AttachmentTypeIconProps) {
    const Icon = ICONS[attachmentIconKind(mimeType)];
    return <Icon className={className} aria-hidden="true" />;
}

export { AttachmentTypeIcon };
